import React from 'react'
import { useParams, Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { Card, CardContent } from './ui/card'
import { Button } from './ui/button'
import { useLanguage } from '../LanguageProvider'

export function DevBoardDetail() {
  const { slug } = useParams<{ slug: string }>()
  const { language } = useLanguage()

  const boards = [
    {
      slug: 'ardugsm',
      name: 'ArduGSM',
      image: 'arduGSM-1.png',
      description: 'ArduGSM, Arduino UNO (Atmega328P),SIM800C GSM modülü, 2 adet röle ve buzzer barındıran tümleşik bir kontrol kartıdır. Dahili 3A regülatör sayesinde güvenilir güç bağlantısı sağlar. Type-C USB konnektörü ile Arduino kolayca programlanabilir.',
      features: [
        { label: 'Arduino UNO', value: 'ATmega328P' },
        { label: 'GSM Modül', value: 'SIM800C' },
        { label: 'Röle', value: '2 Adet' },
        { label: 'Buzzer', value: '1 Adet' },
        { label: 'SIM Kart', value: 'Mikro SIM (TVS korumalı)' },
        { label: 'Ses', value: 'Dahili mikrofon & hoparlör konnektörü' },
        { label: 'Anten', value: '3 dBi 90° SMA' },
        { label: 'Regülatör', value: 'Dahili LM2596S 3A voltaj regülatörü' },
        { label: 'Koruma', value: 'Ters polarite & TVS koruma' },
        { label: 'Bağlantı Türü', value: 'USB Type C' },
        { label: 'Çalışma Gerilimi', value: '12V DC 1A' },
      ],
    },
    {
      slug: 'esp32-ethernet-devboard',
      name: 'ESP32 Ethernet Devboard',
      image: 'esp32-eth_devboard.png',
      description: 'ESP32 Ethernet Geliştirme Modülü, Wi-Fi, Ethernet ve Bluetooth bağlantısını destekleyen, endüstriyel IoT projeleri için tasarlanmış bir geliştirme kartıdır. Dahili LAN8720 tabanlı Ethernet PHY arayüzü sayesinde doğrudan RJ45 portu üzerinden kablolu ağ bağlantısı sağlar. USB Type-C üzerinden programlanabilir ve Arduino IDE veya PlatformIO ortamında kolayca kullanılabilir.',
      usageAreas: [
        'IoT cihazları',
        'Endüstriyel veri toplama sistemleri',
        'Akıllı bina otomasyonu',
        'Ethernet tabanlı sensör ağları',
        'Web sunuculu kontrol sistemleri',
        'IP tabanlı erişim kontrol cihazları (örnek: RFID + Ethernet)'
      ],
      features: [
        { label: 'Mikrodenetleyici', value: 'ESP32-WROOM-32D' },
        { label: 'Çekirdek', value: 'Dual-core (240 MHz’e kadar)' },
        { label: 'RAM', value: '520 KB' },
        { label: 'Flash', value: '4 MB (SPI Flash)' },
        { label: 'Bağlantı', value: 'Wi-Fi 2.4GHz 802.11 b/g/n / Ethernet (LAN8720 PHY) / Bluetooth v4.2 (BR/EDR + BLE)' },
        { label: 'Programlama Arayüzü', value: 'USB Type-C' },
        { label: 'Besleme', value: '5V (USB Type-C veya 5V pin)' },
        { label: 'GPIO Pinleri', value: 'Tüm standart ESP32 pinlerine erişim sağlanır' },
      ],
      sampleCode: `#include <Arduino.h>
#include <ETH.h>
#include <HTTPClient.h>

#define ETH_ADDR 1
#define ETH_POWER_PIN -1
#define ETH_MDC_PIN 23
#define ETH_MDIO_PIN 18
#define ETH_TYPE ETH_PHY_LAN8720
#define ETH_CLK_MODE ETH_CLOCK_GPIO17_OUT

const char* GOOGLE_CHECK_URL = "http://clients3.google.com/generate_204";
const unsigned long INTERVAL_MS = 10000;

bool ethReady = false;
HTTPClient http;
unsigned long lastMillis = 0;

void WiFiEvent(WiFiEvent_t event) {
  switch (event) {
    case ARDUINO_EVENT_ETH_START:
      Serial.println("ETH başlatıldı");
      ETH.setHostname("esp32-ethernet");
      break;
    case ARDUINO_EVENT_ETH_CONNECTED:
      Serial.println("ETH bağlandı");
      break;
    case ARDUINO_EVENT_ETH_GOT_IP:
      Serial.print("IP: ");
      Serial.println(ETH.localIP());
      ethReady = true;
      break;
    case ARDUINO_EVENT_ETH_DISCONNECTED:
    case ARDUINO_EVENT_ETH_STOP:
      Serial.println("ETH bağlantısı kesildi");
      ethReady = false;
      break;
    default:
      break;
  }
}

void setup() {
  Serial.begin(115200);
  WiFi.onEvent(WiFiEvent);
  ETH.begin(ETH_ADDR, ETH_POWER_PIN, ETH_MDC_PIN, ETH_MDIO_PIN, ETH_TYPE, ETH_CLK_MODE);
}

void loop() {
  if (ethReady && millis() - lastMillis >= INTERVAL_MS) {
    lastMillis = millis();
    http.begin(GOOGLE_CHECK_URL);
    int code = http.GET();
    Serial.printf("HTTP Code: %d\n", code);
    http.end();
  }
}`,
    },
    {
      slug: 'lorawan-devboard',
      name: 'LoRaWan DevBoard',
      image: 'gsm_role.png',
      description: 'LoRaWan DevBoard açıklama',
      features: [
        { label: 'Bağlantı Türü', value: 'LoRaWan' },
        { label: 'Modül', value: 'SX1276' },
        { label: 'Anten', value: '3 dBi 90° SMA' },
        { label: 'Çalışma Gerilimi', value: '3.3V' },
        { label: 'Bağlantı Türü', value: 'USB Type C' },
        { label: 'Çalışma Gerilimi', value: '12V DC 1A' },
      ],
    },
    {
      slug: 'ilimflight-pro',
      name: 'ilimFlight Pro Drone Kontrol Kartı',
      image: 'ilimFlight-Pro_cd.png',
      description: 'ilimFlight Pro, ArduPilot destekleyen tüm araç tiplerinde (multikopter, sabit kanat, helikopter, rover, bot vb.) profesyonel seviyede yüksek doğruluk ve güvenilirlikle çalışmak üzere tasarlanmış, son nesil bir uçuş kontrol bilgisayarıdır.\n Multikopter, Sabit Kanat, Helikopter, Rover, Bot vb. gibi çoklu araç desteği sağlar.',
      features: [
        { label: 'İşlemci', value: 'STM32H743' },
        { label: 'Mimari', value: 'ARM Cortex-M7 | STM32 MCU'},
        { label: 'Frekans', value: '480 MHz' },
        { label: 'Birinci IMU', value: 'ICM-42688-P' },
        { label: 'İkinci IMU', value: 'ICM-20649' },
        { label: 'Barometre', value: 'MS5611 (2 Adet)'},
        { label: 'Manyetometre', value: 'RM3100'},
        { label: 'Flash Memory', value: '2 MB'},
        { label: 'RAM', value: '1 MB'},
        { label: 'UART', value: '5 Adet'},
        { label: 'CAN', value: '2 Adet'},
        { label: 'I2C', value: '4 Adet'},
        { label: 'ADC Girişi', value: '2 Adet'},
        { label: 'SPI', value: '1 Adet'},
        { label: 'PWM Çıkışı', value: '12 Adet'},
        { label: 'RC Input', value: 'SBUS'},
        { label: 'RSSI', value: 'Evet'},
        { label: 'Güç Girişi', value: '12V - 35V DC'},
        { label: 'GPS Port', value: '2 Adet'},
        { label: 'USB', value: 'Type-C'},
        { label: 'SD Kart Girişi', value: 'Micro SD (1 Adet)'},
        { label: 'Çalışma Sıcaklığı', value: '-20°C ile +85°C'},
      ],
    },
    {
      slug: 'gsm-role-kontrol-karti',
      name: 'GSM Röle Kontrol Kartı',
      image: 'gsm_role.png',
      description: 'GSM Röle Kontrol Kartı açıklama',
      androidAppUrl: 'https://play.google.com/store/apps/details?id=com.ilimera.akilli_cihaz_yonetimi&pcampaignid=web_share',
      features: [
        { label: 'Bağlantı Türü', value: 'M2M SIM Kart / Hücresel Veri 10MB/Ay' },
        { label: 'Mobil Uygulama', value: '"ShalterOn" (Android/iOS)' },
        { label: 'Bağlanabilir Cihaz', value: '6 Adet – COM/NO/NC' },
        { label: 'Kontrol Kapasitesi', value: '10A @ 250VAC, 10A @ 30VDC' },
        { label: 'Okuma Girişi', value: '4 adet (Enerji vermeyin!)' },
        { label: 'Buzzer', value: '1 Adet' },
        { label: 'Anten', value: '3M' },
        { label: 'Çalışma Gerilimi', value: '12V DC 1A Adaptör' },
        { label: 'Cihaz Boyutları', value: 'RT 207 Ray Tipi Kutu (Panoya geçmeli / Duvara vida ile montaj)' },
      ],
    },
  ]

  const esp32EthernetUsageAreasEn: string[] = [
    'IoT devices',
    'Industrial data acquisition systems',
    'Smart building automation',
    'Ethernet-based sensor networks',
    'Control systems with web server',
    'IP-based access control devices (e.g. RFID + Ethernet)',
  ]

  const ardugsmFeatureTranslations: Record<string, { label: string; value?: string }> = {
    'Arduino UNO': { label: 'Arduino UNO' },
    'GSM Modül': { label: 'GSM Module' },
    'Röle': { label: 'Relay', value: '2 pcs' },
    'Buzzer': { label: 'Buzzer', value: '1 pc' },
    'SIM Kart': { label: 'SIM Card', value: 'Micro SIM (TVS protected)' },
    'Ses': { label: 'Audio', value: 'On‑board microphone & speaker connector' },
    'Anten': { label: 'Antenna', value: '3 dBi 90° SMA' },
    'Regülatör': { label: 'Regulator', value: 'On‑board LM2596S 3A voltage regulator' },
    'Koruma': { label: 'Protection', value: 'Reverse polarity & TVS protection' },
    'Bağlantı Türü': { label: 'Connection Type', value: 'USB Type‑C' },
    'Çalışma Gerilimi': { label: 'Operating Voltage', value: '12V DC 1A' },
  }

  const esp32EthernetFeatureTranslations: Record<string, { label: string; value?: string }> = {
    'Mikrodenetleyici': { label: 'Microcontroller' },
    'Çekirdek': { label: 'Core', value: 'Dual-core (up to 240 MHz)' },
    'RAM': { label: 'RAM' },
    'Flash': { label: 'Flash' },
    'Bağlantı': { label: 'Connectivity' },
    'Programlama Arayüzü': { label: 'Programming Interface' },
    'Besleme': { label: 'Power Supply', value: '5V (USB Type-C or 5V pin)' },
    'GPIO Pinleri': { label: 'GPIO Pins', value: 'Access to all standard ESP32 pins' },
  }

  const ilimFlightFeatureTranslations: Record<string, { label: string; value?: string }> = {
    'İşlemci': { label: 'Processor' },
    'Mimari': { label: 'Architecture' },
    'Frekans': { label: 'Frequency', value: '480 MHz' },
    'Birinci IMU': { label: 'First IMU' },
    'İkinci IMU': { label: 'Second IMU' },
    'Barometre': { label: 'Barometer' },
    'Manyetometre': { label: 'Magnetometer' },
    'Flash Memory': { label: 'Flash Memory' },
    'RAM': { label: 'RAM' },
    'UART': { label: 'UART', value: '5 pcs' },
    'CAN': { label: 'CAN', value: '2 pcs' },
    'I2C': { label: 'I2C', value: '4 pcs' },
    'ADC Girişi': { label: 'ADC Input', value: '2 pcs' },
    'SPI': { label: 'SPI', value: '1 pc' },
    'PWM Çıkışı': { label: 'PWM Outputs', value: '12 pcs' },
    'RC Input': { label: 'RC Input' },
    'RSSI': { label: 'RSSI' },
    'Güç Girişi': { label: 'Power Input' },
    'GPS Port': { label: 'GPS Ports', value: '2 pcs' },
    'USB': { label: 'USB' },
    'SD Kart Girişi': { label: 'SD Card Slot', value: 'Micro SD (1 pc)' },
    'Çalışma Sıcaklığı': { label: 'Operating Temperature' },
  }

  const board = boards.find(b => b.slug === slug)

  if (!board) {
    return (
      <div className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-foreground mb-4">
              {language === 'en' ? 'Development Board Not Found' : 'Geliştirme Kartı Bulunamadı'}
            </h1>
            <Link to="/urunler/gelistirme-kartlari">
              <Button>{language === 'en' ? 'Go Back' : 'Geri Dön'}</Button>
            </Link>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="py-12">
      {/* Breadcrumb */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-8">
        <Link to="/urunler/gelistirme-kartlari" className="flex items-center text-primary hover:text-primary/90 transition-colors">
          <ArrowLeft size={20} className="mr-2" />
          {language === 'en' ? 'Back to Development Boards' : 'Geliştirme Kartlarına Dön'}
        </Link>
      </div>

      {/* Hero Section - ProjectDetail benzeri */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h1 className="text-4xl lg:text-5xl font-bold text-foreground mb-6">
              {slug === 'ardugsm' && language === 'en'
                ? 'ArduGSM'
                : slug === 'esp32-ethernet-devboard' && language === 'en'
                  ? 'ESP32 Ethernet Devboard'
                  : slug === 'ilimflight-pro' && language === 'en'
                    ? 'ilimFlight Pro Drone Control Board'
                    : board.name}
            </h1>
            <div className="text-lg text-muted-foreground leading-relaxed mb-8">
              {(slug === 'ardugsm' && language === 'en'
                ? 'ArduGSM is an integrated control board that includes Arduino UNO (ATmega328P), SIM800C GSM module, 2 relays and a buzzer. Thanks to its built‑in 3A regulator it provides a reliable power connection and can be easily programmed with Arduino via a Type‑C USB connector.'
                : slug === 'esp32-ethernet-devboard' && language === 'en'
                  ? 'ESP32 Ethernet Development Module is a development board designed for industrial IoT projects, supporting Wi‑Fi, Ethernet and Bluetooth connectivity. With its built‑in LAN8720‑based Ethernet PHY interface, it provides wired network connection directly via the RJ45 port. It can be programmed over USB Type‑C and easily used with Arduino IDE or PlatformIO.'
                  : slug === 'ilimflight-pro' && language === 'en'
                    ? 'ilimFlight Pro is a next-generation flight control computer designed to operate with high accuracy and reliability on all vehicle types supported by ArduPilot (multicopter, fixed-wing, helicopter, rover, boat, etc.). It provides multi-vehicle support such as multicopter, fixed-wing, helicopter, rover and boat.'
                    : board.description
              )
                .split('\n')
                .map((line, index) => (
                <p key={index} className="mb-2">{line}</p>
              ))}
            </div>
            {board.androidAppUrl && (
              <Button 
                size="lg" 
                className="group self-start"
                onClick={() => window.open(board.androidAppUrl!, '_blank', 'noopener,noreferrer')}
              >
                <svg className="w-4 h-4 fill-black dark:fill-white mr-2" viewBox="0 0 24 24">
                  <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
                </svg>
                {language === 'en' ? 'Open in Play Store' : "Play Store'dan"}
              </Button>
            )}
          </div>
          <div>
            <img
              src={`/${board.image}`}
              alt={slug === 'ardugsm' && language === 'en'
                ? 'ArduGSM'
                : slug === 'ilimflight-pro' && language === 'en'
                  ? 'ilimFlight Pro Drone Control Board'
                  : board.name}
              className="w-full h-auto rounded-lg shadow-xl"
            />
          </div>
        </div>
      </section>

      {/* Kullanım Alanları */}
      {board.usageAreas && (board as any).usageAreas.length > 0 && (
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-16">
          <h2 className="text-3xl font-bold text-foreground mb-8">
            {language === 'en' ? 'Use Cases' : 'Kullanım Alanları'}
          </h2>
          <Card>
            <CardContent className="p-6">
              <ul className="grid grid-cols-1 md:grid-cols-2 gap-3 list-disc pl-6">
                {(board as any).usageAreas.map((area: string, index: number) => {
                  const translated =
                    slug === 'esp32-ethernet-devboard' && language === 'en'
                      ? esp32EthernetUsageAreasEn[index] ?? area
                      : area

                  return (
                    <li key={index} className="text-muted-foreground">
                      {translated}
                    </li>
                  )
                })}
              </ul>
            </CardContent>
          </Card>
        </section>
      )}

      {/* Sadece Teknik Özellikler Bölümü */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-16">
        <h2 className="text-3xl font-bold text-foreground mb-8">
          {language === 'en' ? 'Technical Specifications' : 'Teknik Özellikler'}
        </h2>
        <Card>
          <CardContent className="p-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {board.features.map((feature, index) => (
                <div key={index} className="flex justify-between items-center py-3 border-b border-gray-100">
                  {(() => {
                    let label = feature.label
                    let value = feature.value

                    if (slug === 'ardugsm' && language === 'en') {
                      const tr = ardugsmFeatureTranslations[feature.label]
                      if (tr) {
                        label = tr.label
                        if (tr.value) value = tr.value
                      }
                    } else if (slug === 'esp32-ethernet-devboard' && language === 'en') {
                      const tr = esp32EthernetFeatureTranslations[feature.label]
                      if (tr) {
                        label = tr.label
                        if (tr.value) value = tr.value
                      }
                    } else if (slug === 'ilimflight-pro' && language === 'en') {
                      const tr = ilimFlightFeatureTranslations[feature.label]
                      if (tr) {
                        label = tr.label
                        if (tr.value) value = tr.value
                      }
                    }

                    return (
                      <>
                        <span className="font-medium text-primary">{label}:</span>
                        <span className="text-muted-foreground">{value}</span>
                      </>
                    )
                  })()}
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      </section>

      {/* Programlama ve Kullanım */}
      {slug !== 'ilimflight-pro' && (
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-16">
          <h2 className="text-3xl font-bold text-foreground mb-8">
            {language === 'en' ? 'Programming and Usage' : 'Programlama ve Kullanım'}
          </h2>
          <Card>
            <CardContent className="p-6">
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                <li>
                  {language === 'en'
                    ? 'Can be easily programmed via Arduino IDE or PlatformIO.'
                    : 'Arduino IDE veya PlatformIO üzerinden kolayca programlanabilir.'}
                </li>
                <li>
                  {language === 'en'
                    ? 'All libraries supported by the board can be used.'
                    : 'İlgili kartın desteklediği tüm kütüphaneler kullanılabilir.'}
                </li>
              </ul>
            </CardContent>
          </Card>
        </section>
      )}

      {/* Örnek Kod */}
      {(board as any).sampleCode && (
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-16">
          <h2 className="text-3xl font-bold text-foreground mb-8">
            {language === 'en' ? 'Sample Code' : 'Örnek Kod'}
          </h2>
          <Card>
            <CardContent className="p-6">
              <pre className="bg-[#1e1e1e] text-gray-100 p-6 rounded-lg overflow-x-auto">
                <code className="text-sm whitespace-pre">{(board as any).sampleCode}</code>
              </pre>
            </CardContent>
          </Card>
        </section>
      )}

      {/* Lisanslama */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-16">
        <h2 className="text-3xl font-bold text-foreground mb-8">
          {language === 'en' ? 'Licensing' : 'Lisanslama'}
        </h2>
        <Card>
          <CardContent className="p-6">
            <p className="text-muted-foreground">
              {language === 'en'
                ? `${board.name} has been developed by İLİMERA TECHNOLOGY.`
                : `${board.name} İLİMERA TEKNOLOJİ tarafından geliştirilmiştir.`}
            </p>
          </CardContent>
        </Card>
      </section>
    </div>
  )
}
